import { CurrencyPipe } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SortService } from '@syncfusion/ej2-angular-grids';
import { ToastrService } from 'ngx-toastr';
import { Subject, Subscription, take } from 'rxjs';
import { GeneralService } from 'src/app/services/general.service';
import { OperationRentalService } from 'src/app/services/Rentals.service';
import { customCurrencyPipe } from 'src/app/Shared/customCurrency.pipe';
import { ASLicenseSettings } from 'src/app/Shared/model/GeneralModel';
import { ANGULAR_MODULES, SYNCFUSION_MODULES } from 'src/app/Shared/shared-imports';

@Component({
  selector: 'app-ops-vendor-daily-rental',
  standalone: true,
  imports: [
    ...SYNCFUSION_MODULES,
    ...ANGULAR_MODULES
  ],
  providers: [customCurrencyPipe, CurrencyPipe, SortService],
  templateUrl: './ops-vendor-daily-rental.html',
  styleUrls: ['./ops-vendor-daily-rental.scss']
})
export class OpsVendorDailyRental implements OnInit, OnDestroy {
  // rentalForm: FormGroup;

  private destroy$ = new Subject<void>();
  tempRecordNo;
  noLayout = false;

  constructor(
    private operationRentalService: OperationRentalService,
    private custom: customCurrencyPipe,
    private generalService: GeneralService
  ) { }

  ngOnInit(): void {
    this.getASCloudLicenseSettings();
  }

  getASCloudLicenseSettings(): void {
    const licenseSettings = this.generalService.ASLicenseSettings;
    if (licenseSettings !== null) {
      this.noLayout = licenseSettings.NoLayout ?? false;
      return;
    }

    this.generalService.getASCloudLicenseSettings().pipe(take(1)).subscribe({
      next: (res: ASLicenseSettings) => {
        this.generalService.ASLicenseSettings = res;
        this.noLayout = res.NoLayout ?? false;
      },
      error: () => {
        this.noLayout = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
